import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useI18n } from '../i18n';
import { RootState } from '../store';

import { ensureReminderChannel, syncReminders } from './reminders';

/** A clock that re-renders its component every `ms` milliseconds. */
export const useNow = (ms = 1000): Date => {
    const [now, setNow] = useState(() => new Date());
    useEffect(() => {
        const id = window.setInterval(() => setNow(new Date()), ms);
        return () => window.clearInterval(id);
    }, [ms]);
    return now;
};

/** "07:05:09" for a duration in milliseconds. */
export const formatCountdown = (ms: number): string => {
    const total = Math.max(0, Math.ceil(ms / 1000));
    const p = (n: number) => String(n).padStart(2, '0');
    return `${p(Math.floor(total / 3600))}:${p(Math.floor((total % 3600) / 60))}:${p(total % 60)}`;
};

/**
 * Keeps the device's reminders matching the person's choice, today's draw and the language.
 * Runs on launch and whenever any of them change, so a draw cancels today's morning nudge.
 */
export const useReminders = (): void => {
    const { language } = useI18n();
    const tarot = useSelector((s: RootState) => s.tarot);
    useEffect(() => {
        ensureReminderChannel(language).then(() =>
            syncReminders(tarot, language)
        );
        // `tarot` as a whole: the plan depends on `daily` and `reminders`, and a re-plan is cheap.
    }, [tarot.reminders, tarot.daily, language]);
};
